import React, { ReactNode } from "react";
import { IconListRow } from "@sinch/components/IconListRow/IconListRow";
import { Link } from "@mui/material";

export const ContactLink: React.FC<{ icon: React.ElementType; href: string; label: ReactNode }> = ({
  icon,
  href,
  label,
}) => (
  <IconListRow icon={icon} iconSize="xs">
    <Link
      href={href}
      sx={(theme) => ({
        "&:hover": {
          color: theme.palette.primary.main,
        },
      })}
      variant="descriptionSmall"
    >
      {label}
    </Link>
  </IconListRow>
);
